import React, { useCallback } from 'react'
import clsx from 'clsx'

import { EditorProps, SelectOption } from '../../../types'

export interface Props extends EditorProps<Array<SelectOption> | SelectOption> {
  options: Array<SelectOption>
  multiple?: boolean
  className?: string
  style?: React.CSSProperties
}

const SelectEditor: React.FC<Props> = ({
  value,
  onChange,
  options,
  multiple,
  className,
  style,
}) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const optionSelected = options.find(
        option => option.value === event.target.value,
      ) as SelectOption

      if (multiple) {
        if (value && Array.isArray(value)) {
          if (value.find(option => option.value === optionSelected.value)) {
            onChange(
              value.filter(option => option.value !== optionSelected.value),
            )
          } else {
            onChange([...value, optionSelected])
          }
        } else {
          onChange([optionSelected])
        }
      } else {
        onChange(optionSelected)
      }
    },
    [options, multiple, value, onChange],
  )

  return (
    <select
      data-testid="select-editor-input"
      className={clsx(
        'bg-transparent',
        className,
        multiple ? 'js-multiple' : '',
      )}
      style={style}
      onChange={handleChange}
      value={
        Array.isArray(value)
          ? value.map(option => option.value)
          : value
          ? value.value
          : undefined
      }
      multiple={multiple}
    >
      {options.map(option => (
        <option key={option.value} value={option.value} className="select-none">
          {option.label}
        </option>
      ))}
    </select>
  )
}

SelectEditor.defaultProps = {
  multiple: false,
}

export default SelectEditor
